<template>
  <div class="member">
    <div class="member_titleBOx">
      <p class="member_title">会员单位</p>
      <p class="memberBtn" @click="gotoMeber">查看更多 > </p>
    </div>
    <div class="memberList">
      <div
        v-for="(item, index) in memberList"
        :key="index"
        class="memberListBox"
        @click="memberDetalie(item.linkUrl)"
      >
        <el-image class="memberImg" style="width: 224px; height: 80px" :src="item.logoPath"></el-image>
      </div>
    </div>
    
  </div>
</template>
<script>
export default {
  name: "member",
  props: {
    memberList: Array,
  },
  data() {
    return {};
  },
  methods: {
    memberDetalie(linkUrl){
      if(linkUrl){
        window.open(linkUrl, "_blank");
      }
    },
    gotoMeber() {
      let routeData = this.$router.resolve({
        name: "member",
      });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>
<style scoped lang="less">
.member {
  background-color: #fff;
  padding-bottom: 28px;
  padding-top: 22px;
  .member_titleBOx {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
    .member_title {
      font-size: 24px;
      font-weight: 500;
    }
  }
  .memberList {
    width: 1200px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 224px 224px 224px 224px 224px;
    grid-column-gap: 20px;
    grid-row-gap: 20px;
    .memberListBox {
      cursor: pointer;
    }
    .memberImg {
      border-radius: 8px;
      border: 1px solid #EEEEEE;
      &:hover {
        box-shadow: 0px 1px 20px 3px rgba(0,0,0,0.1);
      }
    }
  }
  .memberBtn {
    cursor: pointer;
    color: #000;
    font-size: 13px;
    &:hover {
      color: #2d50a1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/association/components/member.vue